import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../apiConfig';

export const uploadRetrievalDocument = createAsyncThunk(
  'documentRetrieval/upload',
  async ({ jwtBearer, file, partner_loan_id }, { rejectWithValue }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('partner_loan_id', partner_loan_id);

    try {
      const response = await axios.post(
        `${BASE_URL}document/retrieval/upload/document/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      console.log('response slice',response)

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.detail || error.response.data.message || 'Upload failed');
      }
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  status: 'idle',
  error: null,
};

const uploadRetrievalDocumentSlice = createSlice({
  name: 'documentRetrieval',
  initialState,
  reducers: {
    resetUploadStatus: (state) => {
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadRetrievalDocument.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(uploadRetrievalDocument.fulfilled, (state) => {
        state.status = 'succeeded';
        state.error = null;
      })
      .addCase(uploadRetrievalDocument.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetUploadStatus } = uploadRetrievalDocumentSlice.actions;
export default uploadRetrievalDocumentSlice.reducer;